import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3395c0fc")
const _hoisted_1 = { class: "show-video-container" }
const _hoisted_2 = ["src"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList, (item) => {
        return (_openBlock(), _createBlock(_component_van_image, {
          radius: "10",
          key: item.id,
          onClick: ($event: any) => (_ctx.onClickVideo(item)),
          class: "img",
          src: item.url + '?imageView2/1/w/200/h/200/rotate/0'
        }, null, 8, ["onClick", "src"]))
      }), 128))
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.showVideos,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_ctx.showVideos = $event)),
      closeable: "",
      style: {"width":"85%","height":"85%","background":"none"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("video", {
          controls: "",
          src: _ctx.selectedVideo,
          style: {"width":"100%","height":"100%"}
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}